// Usage: https://www.chartjs.org/
import Chart from 'chart.js/auto';

//Chart.defaults.global.defaultFontFamily = "'Ubuntu', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
window.Chart = Chart;